import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { Functions, httpsCallable } from '@angular/fire/functions';

import { AppCheck, getToken } from '@angular/fire/app-check';

import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Network } from '@capacitor/network';
import { arrayUpsert } from '@datorama/akita';
import { environment } from '@env/environment';
import { IDefinition } from '@interfaces/definition.interface';
import { DefinitionsStore } from './definitions.store';
import { DefinitionsQuery } from './definitions.query';
import { FileListItem } from '@shared/interfaces/firmware.interface';
import { Storage, ref, listAll, ListResult } from '@angular/fire/storage';
@Injectable({
  providedIn: 'root',
})
export class DefinitionsService {
  public existingFiles: string[] = [];

  constructor(
    //private angularFireStorage: AngularFireStorage,
    private httpClient: HttpClient,
    private definitionsStore: DefinitionsStore,
    private definitionsQuery: DefinitionsQuery,

    private appCheck: AppCheck, // ← inject AppCheck

    private angularFireStorage: Storage,
    private functions: Functions,
  ) {
    // console.log('definition service called');
    this.existingFiles = [];
  }

  /*
  public async loadDefinitions(): Promise<void> {
    const existing = this.definitionsStore.getValue().unitConfigs;
    await this.updateExistingFiles();

    let firebaseStorageDefinitions: ListResult;

    await Network.getStatus().then(async (res) => {
      if (res.connected) {
        //const storage = getStorage(); // Initialize Firebase Storage
        const storageRef = ref(this.angularFireStorage, 'definitions/'); // Create a reference to 'definitions'
        firebaseStorageDefinitions = await listAll(storageRef); // List all items in the 'definitions' directory
        //firebaseStorageDefinitions = await this.angularFireStorage.ref('definitions').listAll().toPromise();
      }
    });
    // console.log(firebaseStorageDefinitions);
    // console.log(this.existingFiles);
    const newItems = firebaseStorageDefinitions?.items
      .filter((x) => !this.existingFiles?.includes(x.name))
      .map((x) => ({ name: x.name, fullPath: x.fullPath }));

    //console.log(newItems, 'newItems');
    if (newItems && newItems?.length > 0) {
      const functionsObservable = newItems.map(
        (x) =>
          this.httpClient.get(environment.functions.storageDownload, {
            responseType: 'json',
            params: { path: x.fullPath },
          }) as Observable<IDefinition>
      );

      const jsonData = await forkJoin(functionsObservable).toPromise();
      //console.log(jsonData, "jsonData")
      for (const [index, data] of newItems.entries()) {
        await this.saveNewDefinition(jsonData[index], data.fullPath);
      }
    }

    await this.setupDefinitionsState();
  }*/

  public async loadDefinitions(): Promise<void> {
    await this.updateExistingFiles();

    let fileList: { name: string; fullPath: string }[] = [];

    const network = await Network.getStatus();
    if (network.connected) {
      try {
        // Call Cloud Function instead of listAll()
        const getList = httpsCallable<{ folder: string }, { files: FileListItem[] }>(this.functions, 'getFileList');

        const result = await getList({ folder: 'definitions' });
        fileList = result.data.files;
      } catch (error) {
        console.error('Failed to get definitions list:', error);
        return;
      }
    }

    // Rest of your existing logic stays exactly the same
    const newItems = fileList
      .filter((x) => !this.existingFiles?.includes(x.name))
      .map((x) => ({ name: x.name, fullPath: x.fullPath }));

    if (newItems && newItems?.length > 0) {
      const downloadFile = httpsCallable<{ path: string }, IDefinition>(this.functions, 'downloadJsonFile');

      const jsonData = await Promise.all(newItems.map((x) => downloadFile({ path: x.fullPath }).then((r) => r.data)));
      /*const functionsObservable = newItems.map(
        (x) =>
          this.httpClient.get(environment.functions.storageDownload, {
            responseType: 'json',
            params: { path: x.fullPath },
          }) as Observable<IDefinition>,
      );

      const jsonData = await forkJoin(functionsObservable).toPromise();*/

      for (const [index, data] of newItems.entries()) {
        await this.saveNewDefinition(jsonData[index], data.fullPath);
      }
    }

    await this.setupDefinitionsState();
  }

  public async setupDefinitionsState(): Promise<void> {
    await this.updateExistingFiles();
    //console.log('this.existingFiles', this.existingFiles);
    if (this.existingFiles) {
      for (const [index, file] of this.existingFiles?.entries()) {
        //console.log(index, file);
        Filesystem.readFile({
          path: 'definitions/' + file,
          directory: Directory.Data,
          encoding: Encoding.UTF8,
        }).then((result) => {
          let newDefinition = {} as IDefinition;
          newDefinition = { ...JSON.parse(result.data as string), id: index };
          // console.log(newDefinition);
          var splittedFileName = file.split('.');
          // console.log(splittedFileName);
          const ecuId = parseInt(splittedFileName[0], 10);
          const compVersion = parseInt(splittedFileName[1], 10);
          const buildVersion = parseInt(splittedFileName[2], 10);
          //console.log(ecuId, compVersion, buildVersion);
          let buildNumber;
          if (splittedFileName && splittedFileName.length > 3) {
            var splitted_ = splittedFileName[3].split('_');
            if (splitted_ && splitted_.length > 0) {
              buildNumber = parseInt(splitted_.reverse()[0], 10);
            }
          }

          if (isNaN(buildVersion)) {
            Filesystem.deleteFile({
              path: 'definitions/' + file,
              directory: Directory.Data,
            })
              .then((res) => {
                console.log('Deleted file *' + file + '* from local storage');
                //console.log(res);
              })
              .catch((err) => {
                // console.log('Could not delete file *' + file + '* from local storage');
                console.log(err);
              });
          }

          this.definitionsStore.update((state) => ({
            unitConfigs: [...state.unitConfigs, { ...newDefinition, ecuId, compVersion, buildVersion, buildNumber }],
          }));
        });
      }
    }
  }

  public async updateExistingFiles(): Promise<void> {
    //console.log('updateExistingFiles');

    try {
      // Check if the directory exists
      await Filesystem.stat({
        path: 'definitions',
        directory: Directory.Data,
      });
      //  console.log('Directory already exists.');
    } catch (err) {
      console.log('Directory not found. Creating it...');

      try {
        await Filesystem.mkdir({
          directory: Directory.Data,
          path: 'definitions',
          recursive: true, // Ensure parent directories are created
        });
        //  console.log('Directory created successfully.');
      } catch (mkdirErr) {
        console.error('Error creating directory:', mkdirErr);
      }
    }

    // Now that the directory exists, try reading files
    try {
      const readResult = await Filesystem.readdir({
        directory: Directory.Data,
        path: 'definitions',
      });

      //  console.log('Files in definitions directory:', readResult.files);
      this.existingFiles = readResult.files.map((x) => x.name);
    } catch (readErr) {
      console.error('Error reading definitions directory:', readErr);
    }
  }

  public async saveNewDefinition(definition, path: string) {
    try {
      // Write the file
      const result = await Filesystem.writeFile({
        path,
        recursive: true,
        data: JSON.stringify(definition),
        directory: Directory.Data,
        encoding: Encoding.UTF8,
      });

      // console.log('File written successfully:', result);

      // Read the file back to verify it was written correctly
      const fileData = await Filesystem.readFile({
        path: path,
        directory: Directory.Data,
        encoding: Encoding.UTF8,
      });

      //console.log('File content read:', path, fileData.data);

      // Compare the content
      if (fileData.data === JSON.stringify(definition)) {
        console.log('File verification successful: Data matches');
      } else {
        console.error('File verification failed: Data mismatch');
      }
      const allFiles = await Filesystem.readdir({ directory: Directory.Data, path: '' });
      // console.log('All directories/files in Directory.Data:', allFiles);
      return result;
    } catch (error) {
      console.error('Error writing file:', error);
    }
  }

  public async addActiveUnitConfig(unitConfig): Promise<void> {
    this.definitionsStore.update((state) => ({
      activeUnitConfigs: arrayUpsert(state.activeUnitConfigs, unitConfig.id, unitConfig),
    }));
  }
}
